import { useEffect, useRef, useState } from 'react';
import { CabinSocket, type WsStatus } from './websocket';
import { refreshAccessToken } from '../auth/refresh';

export function useRealtimeCells(onCellsAdded: (cells: string[]) => void): {
  status: WsStatus;
} {
  const [status, setStatus] = useState<WsStatus>('connecting');
  const handlerRef = useRef(onCellsAdded);
  handlerRef.current = onCellsAdded;

  useEffect(() => {
    const sock = new CabinSocket({
      onCellsAdded: (cells) => handlerRef.current(cells),
      onStatus: setStatus,
      refreshAccessToken,
    });
    sock.start();
    return () => sock.stop();
  }, []);

  return { status };
}
